module.exports = __webpack_public_path__ + "img/templera_ua.32054c48.webp";